import React from 'react';
import Gap from '../../interfaces/gap.interface';
import TestId from '../../interfaces/test-id.interface';

export interface Props extends Gap, TestId {
  /** Optional CSS classes to apply to the element */
  className?: string;

  /** The element's content */
  children?: React.ReactNode;

  /** The input's id */
  id: string;

  /** An optional label rendered in front of the input */
  label?: string;

  /** Optional message rendered underneath the input */
  message?: React.ReactNode;

  /** Style the input according to it's state (implemented in the child) */
  state?: 'indeterminate' | 'valid' | 'invalid';

  /** How to render the label + input element (defaults to `inline`) */
  variant?: 'inline' | 'stacked';
}

/**
 * HTML Form Input Element
 *
 * Info: since this is more of a technical component, there will be no export in
 * index.ts or corresponding story.
 */
const FormElement = ({
  className = '',
  children,
  gap = 'none',
  id,
  label,
  message,
  variant = 'inline',
  testId,
}: Props): React.ReactElement => (
  <label
    className={`form-element form-element--${variant} flex flex-col w-full gap--${gap} ${className}`}
    htmlFor={id}
    data-testid={testId}
  >
    <div
      className={`
          flex
          items-baseline
          w-full
          ${variant === 'stacked' ? 'flex-col' : ''}
        `}
    >
      {label && (
        <span
          className={`
            skeletonize
            ${variant === 'inline' ? 'mr-5' : 'text-sm text-gray-600 font-light'}
          `}
        >
          {label}
        </span>
      )}
      {children}
    </div>
    {message}
  </label>
);

export default FormElement;
